/* tslint:disable */
/* eslint-disable */
/* @relayHash d760cfc2eca04338858565cd5381604b */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_DelegatesProfile_QueryVariables = {
    uuid: string;
};
export type App_DelegatesProfile_QueryResponse = {
    readonly delegate: {
        readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_delegate">;
    } | null;
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"DelegateProfilePage_manager">;
    } | null;
};
export type App_DelegatesProfile_Query = {
    readonly response: App_DelegatesProfile_QueryResponse;
    readonly variables: App_DelegatesProfile_QueryVariables;
};



/*
query App_DelegatesProfile_Query(
  $uuid: UUID!
) {
  delegate(uuid: $uuid) {
    ...DelegateProfilePage_delegate
  }
  manager {
    ...DelegateProfilePage_manager
  }
}

fragment CourseTable_delegate on Delegate {
  myCourses {
    status
    expiresAt
    enrolledAt
    certificateURL
    progress {
      total
      completed
    }
    partTwo {
      status
      certificateURL
      expiresAt
    }
    course {
      __typename
      name
      category {
        name
      }
      ... on OnlineCourse {
        partTwo {
          __typename
          ident: id
        }
      }
    }
  }
  myClassroomCourses {
    status
    expiresAt
    enrolledAt
    certificateURL
    course {
      __typename
      ident: id
      name
      category {
        name
      }
    }
  }
}

fragment DelegateProfilePage_delegate on Delegate {
  uuid
  firstName
  lastName
  email
  jobTitle
  telephone
  TTC_ID
  lastLogin
  currentBackgroundCheck {
    idExpiryDate
    dbsExpiryDate
  }
  hasActiveBackgroundCheck
  backgroundCheckPending
  company {
    name
  }
  hasSimulatorAccess
  myCourses {
    status
    expiresAt
    enrolledAt
    certificateURL
    progress {
      total
      completed
    }
    partTwo {
      status
      certificateURL
      expiresAt
    }
    course {
      __typename
      name
      category {
        name
      }
      ... on OnlineCourse {
        partTwo {
          __typename
          ident: id
        }
      }
    }
  }
  myClassroomCourses {
    status
    expiresAt
    enrolledAt
    certificateURL
    course {
      __typename
      ident: id
      name
      category {
        name
      }
    }
  }
  ...CourseTable_delegate
  ...DocumentsTable_delegate
  ...ProfileCard_delegate
  documents {
    edges {
      uuid
      name
      expiryDate
    }
  }
}

fragment DelegateProfilePage_manager on Manager {
  ...ProfileCard_manager
}

fragment DocumentsTable_delegate on Delegate {
  currentBackgroundCheck {
    idExpiryDate
    dbsExpiryDate
  }
  documents {
    edges {
      uuid
      name
      url
      expiryDate
      completionDate
      getEmail
    }
  }
}

fragment ProfileCard_delegate on Delegate {
  uuid
  firstName
  profileImageUrl
  lastName
  email
  TTC_ID
  telephone
  jobTitle
  backgroundCheckPending
  hasActiveBackgroundCheck
  pendingBackgroundCheck {
    approvalDate
    applicationSentAt
    applicationReceivedAt
    hasAllResponses
    requestedDBS
    isRenewal
    isVerification
    idExpiryDate
    dbsExpiryDate
    onlyDBS
  }
  currentBackgroundCheck {
    approvalDate
    expiresAt
    idExpiryDate
    dbsExpiryDate
    isVerification
    isCAA
    onlyDBS
  }
}

fragment ProfileCard_manager on Manager {
  firstName
  lastName
  company {
    backgroundCheckPennyPrice
    dbsPennyPrice
    dbsOnlyPennyPrice
    renewalPennyPrice
    name
    verificationSuccessPennyPrice
    verificationFailurePennyPrice
    invoicing {
      dbsUsed
      dbsPrePurchased
      backgroundChecksUsed
      backgroundChecksPrePurchased
      renewalsUsed
      renewalsPrePurchased
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uuid",
            "type": "UUID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "uuid",
            "variableName": "uuid"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "idExpiryDate",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "dbsExpiryDate",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "approvalDate",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "expiresAt",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isVerification",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "onlyDBS",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v12 = [
        (v11 /*: any*/)
    ], v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enrolledAt",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "certificateURL",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": (v12 /*: any*/)
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": "ident",
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_DelegatesProfile_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Delegate",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "DelegateProfilePage_delegate",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "DelegateProfilePage_manager",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_DelegatesProfile_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "delegate",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Delegate",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "jobTitle",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "telephone",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "TTC_ID",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lastLogin",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentBackgroundCheck",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BackgroundCheck",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isCAA",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v10 /*: any*/)
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasActiveBackgroundCheck",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "backgroundCheckPending",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": (v12 /*: any*/)
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasSimulatorAccess",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "myCourses",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MyCourse",
                            "plural": true,
                            "selections": [
                                (v13 /*: any*/),
                                (v8 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "progress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Progress",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "total",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "completed",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "partTwo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MyCourse",
                                    "plural": false,
                                    "selections": [
                                        (v13 /*: any*/),
                                        (v15 /*: any*/),
                                        (v8 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "course",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        (v11 /*: any*/),
                                        (v17 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "OnlineCourse",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "partTwo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "plural": false,
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        (v18 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "myClassroomCourses",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MyCourse",
                            "plural": true,
                            "selections": [
                                (v13 /*: any*/),
                                (v8 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "course",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        (v18 /*: any*/),
                                        (v11 /*: any*/),
                                        (v17 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentPage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Document",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v11 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "url",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "expiryDate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "completionDate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "getEmail",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "profileImageUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pendingBackgroundCheck",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BackgroundCheck",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "applicationSentAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "applicationReceivedAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasAllResponses",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "requestedDBS",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isRenewal",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v9 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v10 /*: any*/)
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "backgroundCheckPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dbsPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "dbsOnlyPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "renewalPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v11 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "verificationSuccessPennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "verificationFailurePennyPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "invoicing",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CompanyInvoicing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "dbsUsed",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "dbsPrePurchased",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "backgroundChecksUsed",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "backgroundChecksPrePurchased",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "renewalsUsed",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "renewalsPrePurchased",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_DelegatesProfile_Query",
            "id": null,
            "text": "query App_DelegatesProfile_Query(\n  $uuid: UUID!\n) {\n  delegate(uuid: $uuid) {\n    ...DelegateProfilePage_delegate\n  }\n  manager {\n    ...DelegateProfilePage_manager\n  }\n}\n\nfragment CourseTable_delegate on Delegate {\n  myCourses {\n    status\n    expiresAt\n    enrolledAt\n    certificateURL\n    progress {\n      total\n      completed\n    }\n    partTwo {\n      status\n      certificateURL\n      expiresAt\n    }\n    course {\n      __typename\n      name\n      category {\n        name\n      }\n      ... on OnlineCourse {\n        partTwo {\n          __typename\n          ident: id\n        }\n      }\n    }\n  }\n  myClassroomCourses {\n    status\n    expiresAt\n    enrolledAt\n    certificateURL\n    course {\n      __typename\n      ident: id\n      name\n      category {\n        name\n      }\n    }\n  }\n}\n\nfragment DelegateProfilePage_delegate on Delegate {\n  uuid\n  firstName\n  lastName\n  email\n  jobTitle\n  telephone\n  TTC_ID\n  lastLogin\n  currentBackgroundCheck {\n    idExpiryDate\n    dbsExpiryDate\n  }\n  hasActiveBackgroundCheck\n  backgroundCheckPending\n  company {\n    name\n  }\n  hasSimulatorAccess\n  myCourses {\n    status\n    expiresAt\n    enrolledAt\n    certificateURL\n    progress {\n      total\n      completed\n    }\n    partTwo {\n      status\n      certificateURL\n      expiresAt\n    }\n    course {\n      __typename\n      name\n      category {\n        name\n      }\n      ... on OnlineCourse {\n        partTwo {\n          __typename\n          ident: id\n        }\n      }\n    }\n  }\n  myClassroomCourses {\n    status\n    expiresAt\n    enrolledAt\n    certificateURL\n    course {\n      __typename\n      ident: id\n      name\n      category {\n        name\n      }\n    }\n  }\n  ...CourseTable_delegate\n  ...DocumentsTable_delegate\n  ...ProfileCard_delegate\n  documents {\n    edges {\n      uuid\n      name\n      expiryDate\n    }\n  }\n}\n\nfragment DelegateProfilePage_manager on Manager {\n  ...ProfileCard_manager\n}\n\nfragment DocumentsTable_delegate on Delegate {\n  currentBackgroundCheck {\n    idExpiryDate\n    dbsExpiryDate\n  }\n  documents {\n    edges {\n      uuid\n      name\n      url\n      expiryDate\n      completionDate\n      getEmail\n    }\n  }\n}\n\nfragment ProfileCard_delegate on Delegate {\n  uuid\n  firstName\n  profileImageUrl\n  lastName\n  email\n  TTC_ID\n  telephone\n  jobTitle\n  backgroundCheckPending\n  hasActiveBackgroundCheck\n  pendingBackgroundCheck {\n    approvalDate\n    applicationSentAt\n    applicationReceivedAt\n    hasAllResponses\n    requestedDBS\n    isRenewal\n    isVerification\n    idExpiryDate\n    dbsExpiryDate\n    onlyDBS\n  }\n  currentBackgroundCheck {\n    approvalDate\n    expiresAt\n    idExpiryDate\n    dbsExpiryDate\n    isVerification\n    isCAA\n    onlyDBS\n  }\n}\n\nfragment ProfileCard_manager on Manager {\n  firstName\n  lastName\n  company {\n    backgroundCheckPennyPrice\n    dbsPennyPrice\n    dbsOnlyPennyPrice\n    renewalPennyPrice\n    name\n    verificationSuccessPennyPrice\n    verificationFailurePennyPrice\n    invoicing {\n      dbsUsed\n      dbsPrePurchased\n      backgroundChecksUsed\n      backgroundChecksPrePurchased\n      renewalsUsed\n      renewalsPrePurchased\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b475005acf7f5785516a8b99eb2dfde2';
export default node;
